import { render, staticRenderFns } from "./RecentUpdate.vue?vue&type=template&id=6b62bd11&scoped=true"
import script from "./RecentUpdate.vue?vue&type=script&lang=js"
export * from "./RecentUpdate.vue?vue&type=script&lang=js"
import style0 from "./RecentUpdate.vue?vue&type=style&index=0&id=6b62bd11&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62bd11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b62bd11')) {
      api.createRecord('6b62bd11', component.options)
    } else {
      api.reload('6b62bd11', component.options)
    }
    module.hot.accept("./RecentUpdate.vue?vue&type=template&id=6b62bd11&scoped=true", function () {
      api.rerender('6b62bd11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/RecentUpdate.vue"
export default component.exports